import nprogress from 'nprogress';
import { ActionTypes, ProjectConfigurationActionTypes } from 'actionsConstants';
import { hitApi, ObservableAjax } from '__common/utils/api';
import {
  SET_LOADER_MSG,
  LOAD_OS_PROJECT_CONFIGURATION,
  UPDATE_OS_PROJECT_CONFIGURATION,
  REDIRECT_TO_OS_PROJECT,
  IMPORT_OS_PROJECT_SUCCESS,
  USER_LOGIN_SUCCESS,
} from 'actions';
import { ActionsObservable } from 'redux-observable';
import { AnyAction, Store } from 'redux';
import { Observable } from 'rxjs';


export function osDesignConfigInitDataRequest(action$, store) {
  return action$.ofType(ActionTypes.OS_DESIGN_CONFIG_INIT_DATA_REQUEST)
    .switchMap((action) => {
      
      // Extract auth token from the payload and set it in Redux state
      const authToken = action.payload.payload?.authToken;
      if (authToken) {
        // Set the auth token in Redux state so hitApi will use it
        store.dispatch(USER_LOGIN_SUCCESS(authToken, 'open-solar', 'opensolar@testing.com', false, false, [], []));
      }
      
      return ObservableAjax({
        takeUntil: action$.ofType(ActionTypes.OS_DESIGN_CONFIG_INIT_DATA_SUCCESS),
        onSuccess: LOAD_OS_PROJECT_CONFIGURATION,
        onErrorMessage: 'Cannot fetch project data',
        socketName: 'project',
        onSocketPending: 'Wait Syncing Open Solar with U-builder.....',
        onSocketStart: 'Importing Open Solar Design into U-builder',
        onSocketFailure: 'Open Solar Import Failure......',
        onErrorAction: () => nprogress.done(),
        link: hitApi('post', `api/v1/opensolar/`, action.payload.payload),
      });
    });
}


  export function importOsFullDesignProject(action$, store) {
    return action$.ofType(ActionTypes.IMPORT_OS_FULL_DESIGN_PROJECT)
      .switchMap((action) => {
        store.dispatch(SET_LOADER_MSG('Importing Open Solar Full Design Project'));
        
        // Extract auth token from the data and set it in Redux state
        const authToken = action.payload.data?.authToken;
        if (authToken) {
          // Set the auth token in Redux state so hitApi will use it
          store.dispatch(USER_LOGIN_SUCCESS(authToken, 'open-solar', 'opensolar@testing.com', false, false, [], []));
        }
        
        return ObservableAjax({
          onSuccess: IMPORT_OS_PROJECT_SUCCESS,
          onErrorMessage: 'Cannot import project',
          socketName: 'project',
          onSocketFailure: 'OS FULL DESIGN IMPORT FAILURE',
          showBackendErrorMsgOnFailure: true,
          onErrorAction: () => nprogress.done(),
          link: hitApi('post', 'api/v1/opensolar_full_design_import/', action.payload.data),
        });
      });
  }

  
  export function redirectOsLandingPageAfterProjectConfig(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
    return action$.ofType(ActionTypes.REDIRECT_OS_PAGE)
      .switchMap(() => {
        const { projectConfiguration: { projectEnvConfig : { os_project_id } } } = store.getState();
                
        store.dispatch(REDIRECT_TO_OS_PROJECT.bind(null, os_project_id));
        return Observable.empty();
      });
  }

